import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface LangChangeEvent {
  lang: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContentConfig {

  public onCurrentLangChange = new Subject<LangChangeEvent>();

  private _currentLang: string;
  /**
   * The lang currently used
   */
  get currentLang(): string {
    return this._currentLang;
  }
  set currentLang(currentLang: string) {
    this._currentLang = currentLang;
    this.onCurrentLangChange.next({ lang: currentLang});
  }

} 